module.exports = __webpack_public_path__ + "assets/img/u2733.a757f6c4.svg";